export default {
  styleOverrides: {
    button: {
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)'
      }
    }
  }
};
